// extracted by mini-css-extract-plugin
export var card = "components-account-__Group-module___card";
export var header = "components-account-__Group-module___header";
export var info = "components-account-__Group-module___info";
export var infoItem = "components-account-__Group-module___infoItem";
export var label = "components-account-__Group-module___label";
export var manage = "components-account-__Group-module___manage";
export var name = "components-account-__Group-module___name";
export var value = "components-account-__Group-module___value";